import type { EntityBase } from './Entities';
import type { AnySection } from './sections';

export interface PanelDesignBase extends EntityBase {
  translations: {
    title: string;
  };
  componentType: string;
}

export interface PanelDesign extends PanelDesignBase {
  sections: AnySection[];
}

export enum PanelDesignMode {
  Merge = 'merge',
  Standalone = 'standalone',
}

export type PanelDesigns = PanelDesign[];
